import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoadScriptService, NavigationService, PipesModule, TrackingV2Service } from '@draeger-academy/common';
import { AppInfoService } from '@draeger-academy/common/lib/services/app-info/app-info.service';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { IResponsiveConfig, ResponsiveModule } from '@viablelogic/ngx-responsive';
import { AutoCompleteSearchV3Module } from '../auto-complete-search/auto-complete-search-v3.module';
import { CookieConsentOverlayService } from '../cookie-consent-overlay';
import { DaLinkModule } from '../da-link';
import { FooterComponent } from './footer.component';

const config : IResponsiveConfig = {
    breakPoints: {
        xs:  { max: 479 },
        sm:  { min: 480,  max: 767 },
        md:  { min: 768,  max: 959 },
        lg:  { min: 960,  max: 1119 },
        xl:  { min: 1120, max: 99999 }, // <-- workaround, as no sizes larger than xl are defined in the design
        xxl: { min: 100000} 
    },
    debounceTime: 100
};

@NgModule({
    declarations: [FooterComponent],
    imports: [
        CommonModule,
        RouterModule,
        DaLinkModule,
        AutoCompleteSearchV3Module,
        PipesModule,
        TranslateModule.forChild(),
        ResponsiveModule.forRoot(config),
        LocalizeRouterModule.forChild([])
    ],
    exports: [FooterComponent],
    providers: [
        NavigationService,
        CookieService,
        CookieConsentOverlayService,
        AppInfoService,
        TrackingV2Service,
        LoadScriptService
    ]
})
export class FooterModule {}
